import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const internalProvisioningRoutes: RouteObject[] = [
  {
    id: "provisioning",
    path: "provisioning",
    children: [
      {
        id: "provisioningIndex",
        path: "",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalProvisioningPage } = await import(
            "features/internal/provisioning/InternalProvisioningPage"
          );
          return { Component: InternalProvisioningPage };
        },
        children: [
          {
            id: "customersTab",
            path: "customers",
            lazy: async () => {
              const { InternalProvisioningCustomersTab } = await import(
                "features/internal/provisioning/tabs/InternalProvisioningCustomersTab"
              );
              return { Component: InternalProvisioningCustomersTab };
            },
            handle: {
              title: i18n.t("internal:customers"),
            },
          },
          {
            id: "usersTab",
            path: "users",
            lazy: async () => {
              const { InternalProvisioningUsersTab } = await import(
                "features/internal/provisioning/tabs/InternalProvisioningUsersTab"
              );
              return { Component: InternalProvisioningUsersTab };
            },
            handle: {
              title: i18n.t("common:users"),
            },
          },
        ],
      },
    ],
  },
  {
    id: "customer",
    path: "provisioning/:customerId/customer",
    handle: {
      showSidebar: true,
    },
    lazy: async () => {
      const { InternalProvisioningCustomerPage } = await import(
        "features/internal/provisioning/InternalProvisioningCustomerPage"
      );
      return { Component: InternalProvisioningCustomerPage };
    },
  },
];
